import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import PayeeFilter from '@Components/PayeeFilter'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import TipaltiIFrame from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/TipaltiIFrame'
import { StoresContext } from '@App/contexts'
import { SelectOption } from '@Components/Selectors/Select'
import { getRightsHolderTipaltiIframe } from '@App/api/routes/rightsholder/rightsholder'
import { observer } from 'mobx-react'
import { TipaltiIframe } from '@Entities/rightsholder'

const PayeeBankingInfo = () => {
    const { rightsholderStore } = useContext(StoresContext)

    const [preloaderIsOpen, setPreloaderIsOpen] = useState(false)
    const [tipaltiIframe, setTipaltiIframe] = useState<TipaltiIframe>({})
    const [selectedPayee, setSelectedPayee] = useState<SelectOption>()

    const getData = async () => {
        setPreloaderIsOpen(true)
        await rightsholderStore.loadPayees()
        const payeeToLoad = rightsholderStore.payeeOptions.length
            ? rightsholderStore.payeeOptions[0]
            : {
                  id: rightsholderStore.currentRightsholderId.toString(),
                  value: rightsholderStore.currentRightsholderId.toString(),
                  label: rightsholderStore.memberSummary.name,
              }
        await setNewSelectedPayee(payeeToLoad)
    }

    const setNewSelectedPayee = async (newSelectedPayee: SelectOption) => {
        setPreloaderIsOpen(true)
        const result = await getRightsHolderTipaltiIframe(
            rightsholderStore.currentRightsholderId,
            Number(newSelectedPayee.id)
        )
        setSelectedPayee(newSelectedPayee)
        setTipaltiIframe(result.data)
        setPreloaderIsOpen(false)
    }

    useEffect(() => {
        getData().then()
    }, [])

    return (
        <>
            <PayeeFilter
                payeeOptions={rightsholderStore.payeeOptions}
                setPayee={setNewSelectedPayee}
                selectedPayee={selectedPayee}
                label="Payee:"
            />
            {preloaderIsOpen || !tipaltiIframe ? (
                <PointPreloader />
            ) : (
                <TipaltiIFrame tipaltiIFrame={tipaltiIframe} setPreloaderIsOpen={setPreloaderIsOpen} />
            )}
        </>
    )
}

export default observer(PayeeBankingInfo)
